import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import Modal from '../../../components/modal/Modal.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import { urlBack } from './utils/center.utils.ts'
import CheckboxCom from '../../../components/common/form-components/checkbox/CheckboxComp.jsx'
import CenterManualFileForm from './form/CenterManualFileForm.tsx'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import AppModal from '../../../component/layout/AppModal.tsx'
import { useTranslation } from 'react-i18next'
import { useDisclosure } from '@mantine/hooks'

const CenterManuals = () => {
  const { t } = useTranslation()
  const { formatDate: formatDateInt } = useIntl()
  const [opened, { open, close }] = useDisclosure(false)

  const { id } = useParams()
  const { inputs, onChangeInputs, updateInputs } = useInputs()
  const [selectedManual, setSelectedManual] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])
  useEffect(() => {
    if (!opened) {
      dataFacade?.reload()
      setSelectedManual()
    }
  }, [opened])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        updateInputs(response.resp)
      }
    }
  }

  const renderBool = (checked) => {
    return <CheckboxCom disabled checked={checked === true} />
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'date',
    getAll: ({ filter, sort, limit, skip }) =>
      CenterService?.manuals?.getAll({ id, filter, sort, limit, skip }),
  })

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        selection: selectedManual,
        onRowSelect: (e) => {
          // console.log(e?.data)
          setSelectedManual(e?.data)
          open()
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="name"
          style={{ width: '20%' }}
          header={t('name')}
        />,
        <Column
          sortable
          field="description"
          style={{ width: '40%' }}
          header={t('description')}
        />,
        <Column sortable field="center" header={t('center')} />,
        <Column
          sortable
          field="installation"
          header={t('installation')}
          align="right"
          body={({ installation }) => renderBool(installation)}
        />,

        <Column
          sortable
          field="date"
          body={({ date }) => formatDateInt(date)}
          align="right"
          header={t('date')}
        />,
        <Column sortable field="mimeType" align="right" header={t('type')} />,
      ]}
    />
  )

  return (
    <CenterSection
      dataFacade={dataFacade}
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(inputs?.centerType))}
            />,
            <AppButton preset="add" onClick={() => open()} />,
          ]}
        />
      }
    >
      {dataTable}
      <AppModal
        opened={opened}
        close={close}
        title={t(
          selectedManual ? 'center.manual.file' : 'center.manual.file.add',
        )}
      >
        <CenterManualFileForm
          centerId={id}
          selectedItem={selectedManual}
          close={close}
        />
      </AppModal>
    </CenterSection>
  )
}

export default CenterManuals
